import React, { useEffect } from 'react';
import parse from 'html-react-parser';

interface TooltipProps {
  tooltipData: string
}

const Tooltip = ({ tooltipData } : TooltipProps) => {
	useEffect(() => {
		const tooltipTargets = document.querySelectorAll('[data-tooltip]') || [];

		tooltipTargets?.forEach((target: Element) => {
			target.addEventListener('mouseenter' || 'touchstart', (e) => {
				e.stopImmediatePropagation();
				const parentNode = target.closest('.page-content' || '.content');
				const tooltipElement = parentNode?.querySelector('.lhp-tooltip');
				const tooltipArrowElement = parentNode?.querySelector('.lhp-tooltip .arrow');

				if (target instanceof HTMLElement && tooltipElement instanceof HTMLElement) {
					let left = target.offsetLeft + (target.offsetWidth / 2) + 'px';
					const top = (target.offsetTop - 10) + 'px';

					if ((target.getBoundingClientRect().left + (target.offsetWidth / 2) - tooltipElement.offsetWidth) < 0 ){
						(tooltipArrowElement as HTMLElement).style.left = target.offsetLeft + (target.offsetWidth / 2) - 10 + 'px';
						left = (tooltipElement.offsetWidth / 2) + 'px';
					}
					tooltipElement.style.left = left;
					tooltipElement.style.top = top;
					tooltipElement.classList.add('isVisible');
				}
			}, false);

			target.addEventListener('mouseleave' || 'touchleave', (e) => {
				e.stopImmediatePropagation();
				const parentNode = target.closest('.page');
				const tooltipElement = parentNode?.querySelector('.lhp-tooltip');
				tooltipElement?.classList.remove('isVisible');
			}, false);
		});
	}, []);

	return (
		<div className="lhp-tooltip">
			<div className="arrow" />
			{ parse(tooltipData) }
		</div>
	);
};

export default Tooltip;